import React from 'react';
import PropTypes from 'prop-types';
import { Image, Button } from 'edcom-ui';
import style from './CollectionsModalFeatureWall.module.less';
import { openLogin, openSignup } from '../../../services/regModal';

export default function CollectionsModalFeatureWall({ closeModal }) {
  return (
    <div className={style.container}>
      <div className={style.roly}>
        <Image
          src="https://cdn.education.com/files/static/collections/roly-collections.png"
          alt="Roly"
        />
      </div>
      <div className={style.text}>
        <h3>Sign up to start collecting!</h3>
        <p>
          Bookmark this to easily find it later. Then send your curated
          collection to your children, or put together your own custom lesson
          plan.
        </p>

        {/*todo: replace signup and login links with modals once implmented*/}
        <div className={style.buttons}>
          <a
            onClick={e => {
              e.preventDefault();
              closeModal();
              openSignup('collections', { signUp: { title: null } });
            }}
          >
            <Button className={style.signup} size="large" color="teal">
              Sign up
            </Button>
          </a>
          <a
            onClick={e => {
              e.preventDefault();
              closeModal();
              openLogin('collections');
            }}
          >
            <Button className={style.login} size="large" color="tertiary">
              Log in
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
CollectionsModalFeatureWall.propTypes = {
  closeModal: PropTypes.func,
};
